import React from 'react';
import { Divider, Grid, Container } from '@material-ui/core';
import { useStyles } from './styles';
import { Typography, Tabs, Tab, Icon } from '@material-ui/core';
import { MedicalSupplyOrders, FarmDiseases, VaccinationRules, FarmMortalityReasons } from '../../components';
import { useTranslation } from 'react-i18next';
import MedicalSuppliesPage from '../../pages/MedicalInformation/MedicalSuppliesPage';
import { useNavigate, useParams } from 'react-router-dom';

const MedicalInformation: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { option } = useParams<{ option: string }>();

  const handleTabChange = (value: number) => {
    switch (value) {
      case 0:
        navigate('/medical-info/orders');
        break;
      case 1:
        navigate('/medical-info/supplies');
        break;
      case 2:
        navigate('/medical-info/diseases');
        break;
      case 3:
        navigate('/medical-info/mortality-reasons');
        break;
      case 4:
        navigate('/medical-info/vaccination-rules');
        break;
      default:
        break;
    }
  };

  const getTabIndex = (): number => {
    if (option && option === 'orders') {
      return 0;
    }
    if (option && option === 'supplies') {
      return 1;
    }
    if (option && option === 'diseases') {
      return 2;
    }
    if (option && option === 'mortality-reasons') {
      return 3;
    }
    if (option && option === 'vaccination-rules') {
      return 4;
    }
    return 0;
  };

  React.useEffect(() => {
    const tabIndex = getTabIndex();
    setTab(tabIndex);
  }, [option]);

  const [tab, setTab] = React.useState(getTabIndex());

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item container md={4} xs={12} spacing={1}>
              <Grid item>
                <Icon fontSize="large" color="primary">
                  {'medical_services'}
                </Icon>
              </Grid>
              <Grid item>
                <Typography component="h2" variant="h6" color="primary">
                  {t('f-com-medical-info')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction="column" className={classes.mt1}>
            <Tabs value={tab} onChange={(_, value) => handleTabChange(value)}>
              <Tab label={t('f-supp-order-history')} id="ordersTab" />
              <Tab label={t('f-supplies')} id="suppliesTab" />
              <Tab label={t('f-com-diseases')} id="diseasesTab" />
              <Tab label={t('f-mortality-reasons')} id="mortalityReasonsTab" />
              <Tab label={t('f-vaccination-rules')} id="vaccinationRulesTab" />
            </Tabs>
            <Divider />
          </Grid>

          <Grid container className={classes.mt3}>
            {tab === 0 && (
              <Grid item xs={12} md={12}>
                <MedicalSupplyOrders />
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12} md={12}>
                <MedicalSuppliesPage />
              </Grid>
            )}
            {tab === 2 && (
              <Grid item xs={12} md={12}>
                <FarmDiseases />
              </Grid>
            )}
            {tab === 3 && (
              <Grid item xs={12} md={12}>
                <FarmMortalityReasons />
              </Grid>
            )}
            {tab === 4 && (
              <Grid item xs={12} md={12}>
                <VaccinationRules />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MedicalInformation;
